export default {

	//reducer const
	GET_WIDGET_LIST: 'GET_WIDGET_LIST',
	WIDGET_LIST:'WIDGET_LIST'
}


// WEBPACK FOOTER //
// ./constants/home.js